export const ADD_TOKEN = 'ADD_TOKEN';
export const ADD_ID = 'ADD_ID';
export const ADD_LANG = 'ADD_LANG';
export const ADD_CURR = 'ADD_CURR';
export const ADD_UNIT = 'ADD_UNIT';
export const ADD_PKUIDLIST = 'ADD_PKUIDLIST';
export const ADD_IDARTICLE = 'ADD_IDARTICLE';
export const ADD_GGTOKEN = 'ADD_GGTOKEN';
export const ADD_EMAIL = 'ADD_EMAIL';
export const ADD_PKUIDSUB = 'ADD_PKUIDSUB';
export const ADD_STRIPETOKEN = 'ADD_STRIPETOKEN';
export const ADD_NAME = 'ADD_NAME';
export const ADD_MODAL = 'ADD_MODAL';
export const ADD_USERNAME = 'ADD_USERNAME';
export const ADD_REGISTER = 'ADD_REGISTER';
export const ADD_LOGIN = 'ADD_LOGIN';
export const ADD_RENAME = 'ADD_RENAME';
export const ADD_RESET = 'ADD_RESET';
export const ADD_STRIPE_POPUP = 'ADD_STRIPE_POPUP';
export const ADD_CONTACT_INFO = 'ADD_CONTACT_INFO';
export const ADD_SELECTED_USER_TYPE = 'ADD_SELECTED_USER_TYPE';
export const SET_ENV = 'SET_ENV';



// WEBPACK FOOTER //
// ./src/constants/AppConstants.js